export type SessionTimerData = {
    message: string;
    availablePeriods: number[];
};

export enum UserAction {
    RESET_TIMER = 'reset',
    QUIT = 'stopgaming'
}

